import PropTypes from "prop-types"

export const THRESHOLD_STATUS = {
  OVER: "over",
  OVER_DOUBLE: "over-double",
}

export const DEFAULT_THRESHOLD_PARAMS = { value: 0.005, isPercent: true }

export const THRESHOLD_PARAMS = PropTypes.shape({
  value: PropTypes.number.isRequired,
  isPercent: PropTypes.bool,
})

export function computeThresholdIcon(value, { value: thresholdValue, isPercent }) {
  if (!value || !Number.isFinite(value)) {
    value = -1
  } else {
    value = Math.abs(value)
  }

  const doubleThresholdValue = thresholdValue * 2

  if (value > doubleThresholdValue) {
    return {
      tooltip: `Over ${doubleThresholdValue}% threshold`,
      icon: THRESHOLD_STATUS.OVER_DOUBLE,
    }
  }
  if (value > thresholdValue) {
    return {
      tooltip: `Over ${thresholdValue}${isPercent ? "%" : ""} threshold`,
      icon: THRESHOLD_STATUS.OVER,
    }
  }
  return null
}
